// Using constants instead of strings used directly prevents errors due to typos etc

export const ADD_TODO = 'ADD_TODO';
export const CLEAR_TODOS = 'CLEAR_TODOS';
export const SET_FILTER = 'SET_FILTER';
export const TOGGLE_TODO = 'TOGGLE_TODO';


// WEBPACK FOOTER //
// ./src/constants/action-types.js